export enum Brand {
    AG = 0,
    Uppie = 1,
    Digital = 1,
    Broker = 2
}
